import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '../lib/utils';

/**
 * Password input with a show/hide eye toggle.
 * Accepts all normal <Input> props (value, onChange, placeholder, minLength, required, autoComplete, etc.).
 * Pass `data-testid` for tests; the eye button gets `${data-testid}-toggle`.
 */
export const PasswordInput = forwardRef(function PasswordInput(
    { className, ...props },
    ref
) {
    const [show, setShow] = useState(false);
    const testid = props['data-testid'];
    return (
        <div className={cn('relative', className)}>
            <Input
                ref={ref}
                {...props}
                type={show ? 'text' : 'password'}
                className={cn('pr-10', props.className)}
            />
            <button
                type="button"
                onClick={() => setShow((s) => !s)}
                aria-label={show ? 'Hide password' : 'Show password'}
                data-testid={testid ? `${testid}-toggle` : undefined}
                tabIndex={-1}
                className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 focus:outline-none focus:ring-2 focus:ring-ring"
            >
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
});
